import { UntypedFormGroup } from "@angular/forms";
import { CellChangeArg, Cellstyle, HotCell } from "~app/common/components/hot-doc/hotdoc/cell";
import { Kapkriteria } from "~app/common/models/constants";
import { Produktmatris } from "../Produktmatris";

export abstract class AbstractPrismatrisCell extends HotCell {
    prismatris: Produktmatris;
    prisradAlert = false;

    constructor(
        prismatris: Produktmatris,
        form: UntypedFormGroup,
        protected value: number,
        flags?: Cellstyle,
        onHandle?: (newValue: CellChangeArg) => void) {

        super(flags, null, (newValue: CellChangeArg) => {
            if (newValue.newValue !== this.value) {
                onHandle(newValue);
                this.value = newValue.newValue;
                form.markAsDirty();
                this.prismatris.markAsDirty();
                newValue.complete();
            }
        });
        this.prismatris = prismatris;
        this.value = value;
    }

    setReadOnly(): void {
        /* eslint-disable no-bitwise */
        this.flags |= Cellstyle.Readonly;
    }

    enablePrisradAlert(showVardematrisPrisrad: boolean) {
        this.prisradAlert = showVardematrisPrisrad;
    }

    protected applyStyle(td: HTMLTableCellElement, cellProperties: any) {
        super.applyStyle(td, cellProperties);

        td.classList.add(HotCell.hotNumber);
        if (this.prismatris.kapkriteria === Kapkriteria.ingaBegransningar) {
            td.classList.add("kapkriteria-inga-begransningar");
        } else if (this.prismatris.kapkriteria === Kapkriteria.endastManuellaKap) {
            td.classList.add("kapkriteria-endast-manuella-kap");
        } else if (this.prismatris.kapkriteria === Kapkriteria.endastVardeaptering) {
            td.classList.add("kapkriteria-endast-vardeaptering");
        } else if (this.prismatris.kapkriteria === Kapkriteria.forbjudetAttKapa) {
            td.classList.add("kapkriteria-forbjudet-att-kapa");
        }

        if (this.prismatris.dirty) {
            td.classList.add(HotCell.hotDirty);
        }

        if (this.prisradAlert && this.prismatris.pris !== this.prismatris.radprisBeraknat) {
            td.classList.add("hot-flash");
            td.title = Math.round((this.prismatris.radprisBeraknat - this.prismatris.pris))?.toString();
        } else {
            td.removeAttribute("title");
        }
    }
}
